import { ChangeDetectorRef, Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./components/shared/header/header.component";
import { environment } from '../environments/environment';
import { AuthService } from './auth/service/auth.service';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from "./components/shared/spinner/spinner.component";
import { LoadingSpinnerService } from './services/spinner/loading-spinner.service';
import { StepperComponent } from "./components/shared/stepper/stepper.component";
import { NotificationComponent } from "./components/shared/notification/notification.component";
import { ProgressBarService } from './services/progress/progress-bar.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, LoadingSpinnerComponent, CommonModule, StepperComponent, NotificationComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'bestaetigungs_app';
  apiUrl = environment.apiUrl;
  isLoading: boolean = false;
  showProgress: boolean = false
  step$: Observable<number | null>;

  constructor(private authService: AuthService,private spinnerService: LoadingSpinnerService, private progressBarService: ProgressBarService,public router: Router,private cdr: ChangeDetectorRef) {
    this.spinnerService.loading$.subscribe((state) => {
      this.isLoading = state;
    });

    this.step$ = this.progressBarService.step$;
  }

  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  private handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      console.log('Tab ist wieder aktiv!');
      this.onTabActivated();
    }
  }

  ngOnInit() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  ngOnDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  onTabActivated() {
    this.authService.visibilitySessionCheck()
  }

  // private visibilityChangeHandler = () => this.checkSessionOnVisible();

  // ngOnInit(): void {
  //   if (this.apiUrl !== 'https://dev.api.tridimo.de/api/' && isPlatformBrowser(this.platformId)) {
  //     this.checkSession();
  //     document.addEventListener('visibilitychange', this.visibilityChangeHandler);
  //   }
  // }

  // ngOnDestroy(): void {
  //   if (isPlatformBrowser(this.platformId)) {
  //     document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
  //   }
  // }

  // private checkSessionOnVisible(): void {
  //   if (isPlatformBrowser(this.platformId) && document.visibilityState === 'visible') {
  //     this.checkSession();
  //   }
  // }

  // private checkSession(): void {
  //   this.authService.visibilitySessionCheck().subscribe({
  //     next: () => {
  //       // Benutzer ist eingeloggt – keine Aktion nötig
  //     },
  //     error: (err) => {
  //       // console.error('Session-Fehler:', err);
  //     },
  //   });
  // }
}
